/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:3fef4143-a3e2-49c1-8963-1c7773192537",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_kogBeic6Z",
    "aws_user_pools_web_client_id": "d5mc6p9n7u66hh61ukipptvls",
    "oauth": {
        "domain": "aec.auth.us-east-1.amazoncognito.com",
        "scope": [
            "email",
            "openid",
            "profile"
        ],
        "redirectSignIn": "http://localhost:3000/,https://https://aec-tool.beg.utexas.edu/,https://oauth.pstmn.io/v1/callback",
        "redirectSignOut": "http://localhost:3000/landing,https://aec-tool.beg.utexas.edu/landing",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "REGION": "us-east-1",
    "USER_POOL_ID": "us-east-1_4lORExfGA",
    "USER_POOL_APP_CLIENT_ID": "4n342bvue8irmttidv0t3pepoi"
};


export default awsmobile;
